import { useContext } from 'react';
import { SettingsContext } from '../context/SettingsProvider/SettingsProvider';

export const useSettings = (): any => {
  return useContext(SettingsContext);
};
